<template>
  <div class="flex flex-col-reverse gap-1 max-w-prose">
    <h2 class="text-sm md:text-base" v-html="heading" />
    <p class="font-heading font-medium text-3xl lg:text-4xl" v-html="label" />
  </div>
</template>

<script setup>
const props = defineProps({
  label: {
    type: String,
    default: ''
  },
  heading: {
    type: String,
    default: ''
  }
})
</script>
